<template>
  <div class="PartnerEdit" v-if="partner && partner.uuid">
    <h2>Éditer une entreprise partenaire ({{ partner.name }})</h2>
    <hr />
    <help-message>
      <h3 slot="title">Édition d'une fiche entreprise</h3>
      <p>
        Vous pouvez ici compléter une fiche entreprise, la modifier, ou y
        ajouter des contacts.<br />Le format de l'adresse à respecter est le
        suivant : <strong>26 rue Marie Magné, 31000 Toulouse, France</strong>.
      </p>
    </help-message>
    <div class="columns is-multiline">
      <div class="column is-half">
        <horiz-field>
          <label class="label" slot="label">Nom</label>
          <input type="text" class="input" v-model="partner.name" />
        </horiz-field>
        <horiz-field>
          <label class="label" slot="label">Site Internet</label>
          <input type="text" class="input" v-model="partner.website" />
        </horiz-field>
        <horiz-field>
          <label for="" class="label" slot="label">Statut de l'entreprise</label>
          <div class="select is-small">
            <select name="" id="" v-model="partner.statut_n">
              <option value="'public'">Public</option>
              <option value="'privé'">Privé</option>
            </select>
          </div>
        </horiz-field>
      </div>
      <div class="column is-half">
        <horiz-field>
          <label class="label" slot="label">Tél.</label>
          <input type="text" class="input" v-model="partner.telephone" />
        </horiz-field>
        <horiz-field>
          <label class="label" slot="label">Adresse</label>
          <input type="text" class="input" v-model="partner.address" />
        </horiz-field>
        <horiz-field>
          <label class="label" slot="label">Logo</label>
          <picture-input
            @update="partner.logo_id = $event.id"
            :item="partner.logo_id"
          />
        </horiz-field>
      </div>
    </div>
    <hr />
    <h3>Équipe :</h3>
    <div class="PartnerContacts has-background-grey-light">
      <div class="tags">
        <div class="tag" v-for="c in partner.contacts" :key="c.uuid">
          {{ c.first_name }}&nbsp;{{ c.last_name }}&nbsp;<router-link
            :to="`/contact/edit/${c.uuid}`"
            ><i class="fas fa-edit"></i
          ></router-link>
        </div>
      </div>
      <div class="ContactAdder">
        <horiz-field>
          <label slot="label" class="label">Ajouter un contact</label>
          <contact-suggestor
            :item="null"
            @update="displayAddContact"
            :partner-context="partner.id"
          ></contact-suggestor>
        </horiz-field>
      </div>
    </div>
    <div class="buttons">
      <button
        class="button is-primary"
        :class="loading ? 'is-loading' : ''"
        @click="save"
      >
        Enregistrer
      </button>
    </div>
  </div>
</template>

<script>
import { additions as a, types as t } from "../../store/actions/partners";
import { types as contactTypes } from "../../store/actions/contacts";
import { hasId } from "../../store/models/_helpers";
import HorizField from "../../components/Form/HorizField";
import ContactSuggestor from "../../components/Form/ContactSuggestor";
import { setSaveState } from "../../util/func";
import PictureInput from "../../components/Form/PictureInput";
import HelpMessage from "../../components/Form/HelpMessage";

export default {
  name: "PartnerEdit",
  components: { HelpMessage, PictureInput, ContactSuggestor, HorizField },
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      partner: {},
      loading: false
    };
  },
  methods: {
    async save() {
      this.loading = true;
      setTimeout(async () => {
        await this.$store.dispatch(t.UPDATE_PARTNER, this.partner);
        setSaveState(this.$router);
        this.loading = false;
      }, 500);
    },
    async displayAddContact(id) {
      if (!hasId(this.partner.contacts, id)) {
        this.partner.contacts.push(
          await this.$store.dispatch(contactTypes.GET_CONTACT_BY_ID, id)
        );
      }
    }
  },
  async mounted() {
    this.partner = await this.$store.dispatch(t.GET_PARTNER_BY_UUID, {
      uuid: this.uuid,
      appends: [a.CONTACTS]
    });
  }
};
</script>

<style lang="scss">
.PartnerEdit {
}

.PartnerContacts {
  padding: 16px;
  border-radius: 3px;
  margin: 1em 0;
}
</style>
